import { OpenFeature } from "@openfeature/react-sdk";
import { FeatureFlagVariables } from "../../../../constants/featureFlag";
import type { IAccountWithEligibility } from "../../../../types/account-with-eligibility.interface";
import mixpanel from "../../mixpanel.config";
import {
  ISEE_SUBSCRIBE_FIRST_EXPERIMENT_PROPERTY,
  UpgradeFirstExperimentVariant,
} from "./upgrade-first-experiment.const";

export function assignUpgradeFirstExperiment(accountData: IAccountWithEligibility): void {
  const isEligible = accountData.upgradeFirstEligible;
  if (!isEligible) {
    return;
  }

  const client = OpenFeature.getClient();
  const isUpgradeFirstEnabled = client.getBooleanValue(FeatureFlagVariables.isUpgradeFirstEnabled, false);

  const variant = isUpgradeFirstEnabled
    ? UpgradeFirstExperimentVariant.UPGRADE_FIRST
    : UpgradeFirstExperimentVariant.COMPLETE_INFO_FIRST;

  mixpanel.people.set_once({
    [ISEE_SUBSCRIBE_FIRST_EXPERIMENT_PROPERTY]: variant,
  });
}
